import { axiosInstance } from "./config";
import { apiFilterOutputJson } from "./apiFilterOutputJson";

export const API_STEPS = {
    first: 'first-step',
    second: 'second-step',
    third: 'third-step',
    fourth: 'fourth-step',
    fifth: 'fifth-step'
}

export const apiSaveStep = async (step = API_STEPS.first, data) => {
    console.log('API - making saving step request', step, apiFilterOutputJson(step, data));
    try {
        let response = await axiosInstance({
            url: step,
            method: 'POST',
            data: apiFilterOutputJson(step, data)
        });
        console.log(response);
        return response;
    } catch (error) {
        console.log(error);
        throw(error);
    }
}